export default "__VITE_ASSET__i$3RzTR$__"